export const shiftNames = {
  SHIFT: 'shift',
  SHIFT_VTO: 'shift_vto',
  OPEN_SHIFT: 'open_shift',
  SHIFT_INVENTORY: 'shift_inventory',
  SHIFT_PICKUP: 'shift_pickup',
};
